import axios from "axios";
import {getApplicantByEmail} from "../../services/ApiServices";




   const state={
            applicant:{},
            loading:false,
            serverResponse:''
   }
   const getters={
       applicant : state => state.applicant,
       loading: state=>state.loading,
       serverResponse:state=>state.serverResponse
   }

   const actions={
        fetchApplicantByEmail({commit},payload){
            state.loading = true
            // const applicantEmail= this.$route.params.id;
            // console.log(this.$route.params.id)
            commit('SET_LOADING',state.loading)
            const elderHeader = JSON.parse(sessionStorage.getItem("headers"))

            axios.get(getApplicantByEmail(payload),{headers: elderHeader})
                .then(response => response.data).then(applicant =>{
                    commit('SET_APPLICANT',applicant)
                    console.log(applicant)
                    state.loading=false
                    commit('SET_LOADING')


                }).catch(err=>{
                    console.log(err)
                    if(err.response===undefined){
                        state.serverResponse="Check your internet connection and try again !!!"
                        commit('SET_RESPONSE',state.serverResponse)
                    }else{
                        state.serverResponse = err.response.data.message
                        commit('SET_RESPONSE',state.serverResponse)
                    }

                    state.loading=false
                    commit('SET_LOADING',state.loading)
                    console.log(err)


                })


             }
   }
   const mutations = {
        SET_APPLICANT(state, applicant) {
            state.applicant = applicant
        },
        SET_LOADING(state,loading){
            state.loading =loading
        },
        SET_RESPONSE(state,serverResponse){
            state.serverResponse = serverResponse
        }
   }
    export default {
        state,
        getters,
        actions,
        mutations

    }